module.exports = __webpack_public_path__ + "img/buy.73ef13ee.svg";